import React from "react";
import useDeleteJob from "../hooks/useDeleteJob";
import useJobLog from "../hooks/useJobLog";
import useJobs from "../hooks/useJobs";

String.prototype.toHHMMSS = function () {
  var sec_num = parseInt(this, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours+':'+minutes+':'+seconds;
}

function ShowInReportProfessor() {
  const { jobsData, jobsError } = useJobs();
  const { fetchLogs, fetchingLogs } = useJobLog();
  const { deleteJob, jobDeleting } = useDeleteJob();

  // Updated headers with new labels
  const headers = [
    ["name", "Category"],
    ["progress", "Status"],
    ["attemptsMade", "Retry"],
    ["timestamp", "Processing Date"],
    ["finishedIn", "Processing Time"],
  ];

  // Only include "COMPLETED" status
  const statuses = ["completed"];

  const isDate = (header) =>
    ["timestamp"].includes(header);

  const calcDelay = (data) =>
    data["processedOn"]
      ? ((data["processedOn"] - data["timestamp"]) / 1000).toFixed(0).toHHMMSS()
      : "";

  const calcDuration = (data) =>
    data["finishedOn"]
      ? ((data["finishedOn"] - data["processedOn"]) / 1000).toFixed(0).toHHMMSS()
      : "";

  return (
    <section>
      <div className="tablewrapper">
        <table>
          <thead>
            <tr>
              {headers.map(([name, label]) => (
                <th key={name}>{label}</th>
              ))}
              <th>Download File</th>
            </tr>
          </thead>
          {statuses.map((status) => (
            <tbody key={status}>
              <tr>
                <td className="subheader" colSpan={headers.length + 1}>
                  {status} ({jobsData[status] ? jobsData[status].length : "0"})
                </td>
              </tr>
              {jobsData[status] &&
                jobsData[status].map((job) => (
                  <tr key={job.id}>
                    
                    {headers.map(([header, label]) => (
                      <td className={header} key={job.id + header}>
                        {header === "progress" && (
                          <div
                            className="value"
                            style={{ width: `${job[header]}%` }}
                          ></div>
                        )}
                        <div className="content">
                          {header === "timestamp" && job[header] ? new Date(job[header]).toLocaleString("ko-KR") : job[header]}
                          {header === "progress" && " %"}
                          {header === "finishedIn" && calcDuration(job)}
                        </div>
                      </td>
                    ))}

                    <td>
                      {job.returnvalue && typeof job.returnvalue === "string" && (
                        <a
                          target="_blank"
                          href={`/exports/${job.returnvalue}`}
                          rel="noreferrer"
                        >
                          <button style={{ color: "green" }}>Download</button>
                        </a>
                      )}
                      <button
                        onClick={() => fetchLogs(job.id)}
                        disabled={fetchingLogs}
                        style={{ color: "orangered" }}
                        className="mx-1"
                      >
                        Logs
                      </button>
                    </td>

                  </tr>
                ))}
            </tbody>
          ))}
        </table>
      </div>
    </section>
  );
}

export default ShowInReportProfessor;
